import _ from 'lodash'

import FictivSymbol from '~/lib/FictivSymbol'

const SHOW = FictivSymbol('estimates/SHOW')
const SHOW_SUCCESS = FictivSymbol('estimates/SHOW_SUCCESS')
const SHOW_FAIL = FictivSymbol('estimates/SHOW_FAIL')

const initialState = {
    itemsById: {},
    indexByParams: {},
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SHOW:
            return Object.assign({}, state, {
                itemsById: {
                    ...state.itemsById,
                    [action.id]: {
                        ...state.itemsById[action.id],
                        loading: true,
                    },
                },
            })
        case SHOW_SUCCESS: {
            const NOW = Date.now()
            const transformedItem = _.identity(action.result)

            return Object.assign({}, state, {
                itemsById: {
                    ...state.itemsById,
                    [action.id]: {
                        ...state.itemsById[action.id],
                        loading: false,
                        fetched_at: NOW,
                        item: transformedItem,
                    },
                },
            })
        }
        case SHOW_FAIL: {
            const NOW = Date.now()

            return Object.assign({}, state, {
                error: action.error,
                itemsById: {
                    ...state.itemsById,
                    [action.id]: {
                        ...state.itemsById[action.id],
                        loading: false,
                        fetched_at: NOW,
                        error: action.error,
                    },
                },
            })
        }

        default:
            return state
    }
}
